module.exports = __webpack_public_path__ + "static/toronto-8-bit-311823c0f3a332abe3b9437ada639fd0.png";